import HiddenInput from "@/components/form/components/HiddenInput";
import { datePickerFormItemProps, datePickerStandardProps } from "@/utils/componentUtils";
import { resolveFormValidationError, setErrorsToForm } from "@/utils/formUtils";
import { dateToIsoDateString } from "@/utils/utils";
import { validations } from "@/utils/validationUtils";
import { DatePicker, Form, Modal } from "antd";
import { useForm } from "antd/es/form/Form";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useChangeCommissionsBatchStep } from "../../../../../common/api/queries";
import { ModalSizes } from "../../../../../common/constants";
import { CommissionsBatchStepDirection } from "../../enums";
import { ChangeCommissionsBatchStepRequest, CommissionsBatch } from "../../types";

type Props = {
  isOpen: boolean;
  onCancel: () => void;
  batch: CommissionsBatch;
};

export const CommissionsBatchChangeStepModalForm = ({ isOpen, onCancel, batch }: Props) => {
  const { t } = useTranslation();

  const [form] = useForm<ChangeCommissionsBatchStepRequest>();

  const changeCommissionsBatchStep = useChangeCommissionsBatchStep({ globalSpinner: false });

  useEffect(() => {
    if (isOpen && batch)
      form.setFieldsValue({
        optimisticLockVersion: batch.optimisticLockVersion,
        direction: CommissionsBatchStepDirection.NEXT,
      });
  }, [form, isOpen, batch]);

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) =>
        changeCommissionsBatchStep.mutate(
          { id: batch.id, object: values },
          {
            onSuccess: onCancel,
            onError: (error) => setErrorsToForm(form, "commissions.batch.attrs.changeStep", error.violations),
          },
        ),
      )
      .catch(resolveFormValidationError);
  };

  return (
    <Modal
      width={ModalSizes.TINY}
      title={t("commissions.batch.titles.setCalculationDate")}
      open={isOpen}
      onCancel={onCancel}
      onOk={handleSubmit}
      confirmLoading={changeCommissionsBatchStep.isPending}
      okText={t("common.save")}
      cancelText={t("common.cancel")}
      afterClose={() => form.resetFields()}
    >
      <Form form={form} layout="vertical" name="changeCommissionsBatchStepForm">
        <HiddenInput name="optimisticLockVersion" />
        <HiddenInput name="direction" />

        <Form.Item
          name="calculationDate"
          label={t("commissions.batch.attrs.calculationDate")}
          rules={[validations.notFuture, validations.notNull]}
          {...datePickerFormItemProps}
          initialValue={dateToIsoDateString(dayjs())}
        >
          <DatePicker {...datePickerStandardProps} maxDate={dayjs()} minDate={dayjs().startOf("month")} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
